const STORAGE_KEY = "sw-ref";

export function captureReferral(code: string): void {
  const next = code.trim().toUpperCase();
  if (!next) return;
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* private mode */
  }
}

export function peekReferral(): string {
  try {
    return (localStorage.getItem(STORAGE_KEY) ?? "").trim().toUpperCase();
  } catch {
    return "";
  }
}

export function clearReferral(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function referralSignupUrl(code: string, origin = typeof window !== "undefined" ? window.location.origin : "https://softwavemarkets.com"): string {
  return `${origin.replace(/\/$/, "")}/register?ref=${encodeURIComponent(code)}`;
}
